import { createSlice } from "@reduxjs/toolkit";
import { Source } from "interfaces";

const initialState: Source = {
  id: "",
  name: "",
  fileName: "",
  fileId: "",
  size: 0,
  type: "PRIVATE",
  createdBy: "",
  author: "",
  isbn: "",
  topicId: "",
  projectId: "",
  fileType: "",
  topic: "",
  lastUpdate: "",
};
export const gestioneSourceSlice = createSlice({
  name: "GestioneSourceSlice",
  initialState: initialState,
  reducers: {
    setSource: (state: any, action: any) => {
      Object.assign(state, action.payload);
    },
  },
});

export const { setSource } = gestioneSourceSlice.actions;

export default gestioneSourceSlice.reducer;
